/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  FontSizes,
  FontWeights,
  ICommandBarStyles,
  ILabelStyles,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

/**
 * Token for the body stack
 */
export const bodyContainerStackTokens = (): IStackTokens => {
  return { childrenGap: "1rem" };
};

/**
 * Styling for the body row stack
 */
export const bodyRowStackStyles = (): IStackStyles => {
  return { root: { display: "flex", justifyContent: "space-between" } };
};

/**
 * Styling for the body column stack
 */
export const bodyColumnStackItemStyles = (): IStackItemStyles => {
  return { root: { width: "50%" } };
};

/**
 * Styling for the header text
 */
export const subHeaderTextStyles = (): ITextStyles => {
  return {
    root: {
      fontWeight: 600,
      fontSize: FontSizes.size18,
      padding: "1rem 1.5rem",
    },
  };
};

/**
 * Styling for the label
 */
export const labelStyles = (): ILabelStyles => {
  return { root: { fontWeight: 600 } };
};

/**
 * Styling for the label without bold
 */
export const labelStylesNormal = (): ILabelStyles => {
  return { root: { fontWeight: "normal" } };
};

export const commandBarStyles: ICommandBarStyles = {
  root: {
    borderRadius: "8px",
    boxShadow: " 0px 1px 4px rgba(0, 0, 0, 0.2)",
    margin: "1rem 0.5rem 0",
    padding: "0.75rem",
    selectors: {
      ["button"]: {
        marginRight: "36px",
      },
      [".ms-Button-label"]: {
        fontSize: "14px",
        fontWeight: FontWeights.semibold,
      },
    },
  },
};

export const commandBarBlockShippingCommandStyle = {
  color: theme.palette.red,
};

export const commandBarUnblockStyles: ICommandBarStyles = {
  root: {
    borderRadius: "8px",
    boxShadow: " 0px 1px 4px rgba(0, 0, 0, 0.2)",
    margin: "1rem 0.5rem 0",
    padding: "0.75rem",
    selectors: {
      ["button"]: {
        marginRight: "36px",
      },
      [".ms-Button-label"]: {
        fontSize: "14px",
        fontWeight: FontWeights.semibold,
      },
    },
  },
};
